import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTypography = styled(Typography)(({ variant }) => ({
  ...(variant === 'body1' && {
    fontWeight: 400,
    style: 'regular',
    fontSize: '14px',
    letterSpacing: 0,
  }),

  ...(variant === 'body2' && {
    fontWeight: 400,
    style: 'regular',
    fontSize: '12px',
    letterSpacing: '1%',
    lineHeight: '112%',
  }),

  ...(variant === 'subtitle1' && {
    fontWeight: 400,
    style: 'medium',
    fontSize: '18px',
    lineHeight: '100%',
    letterSpacing: 0,
  }),

  ...(variant === 'h4' && {
    fontWeight: 700,
    style: 'bold',
    fontSize: '16px',
    lineHeight: '112%',
    letterSpacing: '1%',
  }),

  ...(variant === 'h5' && {
    fontWeight: 500,
    style: 'medium',
    fontSize: '26px',
    lineHeight: '100%',
    letterSpacing: 0,
  }),

  ...(variant === 'h6' && {
    fontWeight: 500,
    style: 'medium',
    fontSize: '20px',
    letterSpacing: 0,
  }),
}));
